export class MoveUsersPools {
    public usersIds: number[];
    public poolsToAdd: number[];
    public poolsToRemove: number[];
}
